import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { withRouter } from 'react-router'
import moment from 'moment'
import { Button, Collapse, Empty, Icon, Layout, Modal, PageHeader, Row, Table, DatePicker } from 'antd'
import { mentors } from '@services/api'
import AddBudgetRow from '@components/Popup/AddBudgetRow'
import { mentorsFormatter } from '@utils/index'
import { hRef, none, tableClass, calendarBug } from '@pages/AgentCommissions/Reports/style.scss'

@inject((store: any) => {
    const { popupStore, authStore } = store
    return { popupStore, authStore }
})
@observer
class MentorsBudget extends Component<any> {
    columns = [
        {
            title: 'תאריך',
            key: 'date',
            align: 'center',
            width: 20,
            render: (_, { usage_date }) => moment(usage_date).format('DD/MM/YY') || ''
        },
        {
            title: 'סכום לחיוב',
            key: 'price',
            align: 'center',
            width: 85,
            render: (_, { budget_amount }) => budget_amount || ''
        },
        {
            title: 'שם לקוח',
            key: 'client_name',
            align: 'right',
            width: 350,
            render: (_, { client_name, client_id }) =>
                client_id ? this.userDiv(client_name, client_id, 'clients') : ''
        },
        {
            title: 'שם סוכן',
            key: 'agent_name',
            align: 'right',
            width: 350,
            render: (_, { agent_name, agent_id }) => (agent_id ? this.userDiv(agent_name, agent_id, 'agents') : '')
        },
        {
            title: 'נושא',
            key: 'title',
            align: 'center',
            width: 350,
            render: (_, { title }) => title || ''
        },
        {
            title: 'פירוט',
            key: 'comment',
            align: 'center',
            width: 40,
            render: (_, { description }) => (description ? this.commentDiv(description) : '')
        }
    ]

    constructor(props) {
        super(props)
        this.state = {
            page: 1,
            pageSize: 5,
            loading: false,
            mentors: [],
            mentors_initial: [],
            createData: false,
            mentor_id: null,
            mentor_search_id: null,
            accepted_sum: null,
            search_date: null
        }
    }

    infoModal = text => Modal.info({ title: text, okType: 'primary' })
    serverErrorMsg = (err: any) => Modal.error({ title: 'שגיאת שרת', content: err })

    commentDiv = description => (
        <a href={'#'} className={`${hRef} ${description ? '' : none}`} onClick={() => this.infoModal(description)}>
            {'לפירוט'}
        </a>
    )

    userDiv = (name, id, role) => {
        // prettier-ignore
        return (
            <div>
                {name} {' - '} <a target={'_blank'} href={`/${role}/${id}`} className={hRef}>{`${id}`}</a>
            </div>
        )
    }

    componentDidMount() {
        const {
            authStore: { roles }
        } = this.props
        if (roles.includes('admin') || roles.includes('mentors_budget')) this.getMentorsBudget()
    }

    getMentorsBudget = () => {
        this.setState({ loading: true })
        mentors
            .getMentorsBudget({})
            .then(({ data }) =>
                this.setState({ mentors_initial: data, mentors: mentorsFormatter(data, null, null), loading: false })
            )
            .catch(() => this.serverErrorMsg('שגיאת קבלת מנטורים'))
            .finally(() => this.setState({ loading: false }))
    }

    createBudgetRow = (id, amount, initial) => {
        // prettier-ignore
        const { popupStore: { togglePopup } } = this.props
        this.dateSearchReset(initial)
        this.setState({ createData: true, mentor_id: id, accepted_sum: amount }, () => togglePopup('addBudgetRow'))
    }

    dateSearchReset = initial => {
        // prettier-ignore
        this.setState({ search_date: null, mentor_search_id: null, mentors: mentorsFormatter(initial, null, null) })
    }

    onDateSearch = (date, dateString, id, initial) => {
        if (date === null) return this.dateSearchReset(initial)
        // prettier-ignore
        this.setState({ search_date: date, mentor_search_id: id, mentors: mentorsFormatter(initial, dateString, id) })
    }

    render() {
        // prettier-ignore
        const { pageSize, loading, mentors, page, createData, search_date, mentors_initial, mentor_search_id } = this.state
        const { columns, createBudgetRow, onDateSearch, dateSearchReset } = this

        return (
            <Layout>
                {createData ? <AddBudgetRow events={this} /> : null}
                <PageHeader onBack={() => window.history.back()} title={'ניהול תקציב מנטורים'} />
                <Collapse accordion>
                    {mentors.map(({ name, remaining_budget, id, budget_rows }, index) => (
                        <Collapse.Panel header={`${name} - תקציב חודשי: ${remaining_budget}`} key={index}>
                            <Row style={{ marginBottom: '20px' }}>
                                <DatePicker.MonthPicker
                                    className={calendarBug}
                                    style={{ width: '115px', border: 'none' }}
                                    value={mentor_search_id == id ? search_date : null}
                                    onChange={(date, dateString) => onDateSearch(date, dateString, id, mentors_initial)}
                                    placeholder={'בחרו תאריך'}
                                    format="YYYY-MM"
                                    disabledDate={current => current && current > moment().endOf('day')}
                                    disabled={!mentors_initial.length}
                                />
                                <Button
                                    onClick={() => dateSearchReset(mentors_initial)}
                                    style={{ width: '115px', marginRight: '10px' }}
                                    disabled={!mentors_initial.length}
                                >
                                    <Icon type={'sync'} />
                                    {'איפוס'}
                                </Button>
                                <Button
                                    onClick={() => createBudgetRow(id, remaining_budget, mentors_initial)}
                                    disabled={remaining_budget == 0}
                                >
                                    <Icon type={'plus-circle'} />
                                    {'יצירת חיוב'}
                                </Button>
                            </Row>
                            {budget_rows.length ? (
                                <Table
                                    className={`center-table ${tableClass}`}
                                    bordered={true}
                                    rowKey="id"
                                    scroll={{ x: 900 }}
                                    loading={loading}
                                    columns={columns}
                                    rowClassName={record => record.id + ''}
                                    dataSource={budget_rows.slice((page - 1) * pageSize, page * pageSize)}
                                    pagination={{
                                        total: budget_rows.length,
                                        pageSize: pageSize,
                                        current: page,
                                        hideOnSinglePage: true,
                                        onChange: page => this.setState({ page })
                                    }}
                                />
                            ) : (
                                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                            )}
                        </Collapse.Panel>
                    ))}
                </Collapse>
            </Layout>
        )
    }
}

export default withRouter(MentorsBudget)
